module.exports = __webpack_public_path__ + "img/2.84ff6507.png";